import { paymentActions } from "../store/payment";
import compose from "ramda/src/compose";
import { connect } from "react-redux";
import View from "./Dashboard";
import { balanceActions } from "../store/balance";
import { packagesActions } from "../store/packages";
import { smsActions } from "../store/SMS";

const mapStateToProps = (state) => {
	return {
		...state.PaymentReducer,
		...state.BalanceReducer,
		...state.PackagesReducer,
		...state.SmsReducer,
	};
};

const mapActionsToProps = {
	...paymentActions,
	...balanceActions,
	...packagesActions,
	...smsActions,
};

export default compose(connect(mapStateToProps, mapActionsToProps))(View);
